
import CashXPdfService from "../../services/pdf/CashXPdfService";
import useLoading from "../useLoading";

export const useCashXPdf = () => {

    const {
        showLoadingIndicator,
        hideLoadingIndicator,
    } = useLoading();

    /**
     * 📄 Descargar PDF
     * Corte X
     */
    const handleDownloadCashXPdf =
        async () => {

            try {

                showLoadingIndicator();

                const {
                    blob,
                    fileName,
                } =
                    await CashXPdfService.download();

                const url =
                    window.URL.createObjectURL(
                        blob
                    );

                const link =
                    document.createElement("a");

                link.href = url;

                link.download =
                    fileName ||
                    "corte_x.pdf";

                document.body.appendChild(
                    link
                );

                link.click();

                link.remove();

                window.URL.revokeObjectURL(
                    url
                );

            } catch (error) {

                console.error(
                    "❌ Error descargando PDF Corte X:",
                    error
                );

            } finally {

                hideLoadingIndicator();

            }
        };

    return {
        handleDownloadCashXPdf,
    };
};

export default useCashXPdf;